import request from '@/utils/request'
// 查询订单
export function fetchList(params) {
  return request({
    url: '/order/list',
    method: 'get',
    params: params
  })
}


export function deliveryOrder(data) {
  return request({
    url: '/order/update/delivery',
    method: 'post',
    data: data
  });
}
export function deliveryBatchOrder(data) {
  return request({
    url: '/order/update/batch/delivery',
    method: 'post',
    data: data
  });
}
export function cancelElectron(params){
  return request({
    url: '/order/cancel/electron',
    method: 'get',
    params: params
  })
}
export function batchElectron(params){
  return request({
    url: '/order/update/batch/electron',
    method: 'post',
    data: params
  })
}
export function batchPringElectron(params){
  return request({
    url: '/order/print/batch/electron',
    method: 'post',
    data: params
  })
}

/**
 * 订单号识别
 * @param data
 * @returns {*}
 */
export function freightSearch(num) {
  return request({
    url: '/order/freight/list',
    method: 'get',
    params: num
  });
}

/**
 * 物流编码
 * @param data
 * @returns {*}
 */
export function freightCode(data) {
  return request({
    url: '/order/freight/code',
    method: 'get',
    params: data
  });
}
/**
 * 快递单号是否重复
 * @param data
 * @returns {*}
 */
export function freightUse(num) {
  return request({
    url: '/order/freight/use',
    method: 'get',
    params: num
  });
}


export function getOrderDetail(id) {
  return request({
    url: '/order/' + id,
    method: 'get'
  });
}

export function updateReceiverInfo(data) {
  return request({
    url: '/order/update/receiverInfo',
    method: 'post',
    data: data
  });
}

export function updateMoneyInfo(data) {
  return request({
    url: '/order/update/moneyInfo',
    method: 'post',
    data: data
  });
}

export function updateOrderNote(params) {
  return request({
    url: '/order/update/note',
    method: 'post',
    params: params
  })
}
// 确认订单
export function confirmOrder(id) {
  return request({
    url: '/order/confirm/' + id,
    method: 'post'
  })
}
// 放弃订单
export function giveUpOrder(params) {
  return request({
    url: '/order/give/up',
    method: 'post',
    data: params
  })
}
// 生成发货单
export function createInvoice(id) {
  return request({
    url: '/order/invoice/' + id,
    method: 'post'
  })
}
// 发货订单
export function invoiceList(params) {
  return request({
    url: '/order/invoice/list',
    method: 'get',
    params: params
  })
}

// 超时日期
export function expectTime(params) {
  return request({
    url: '/order/expectTime',
    method: 'get',
    params: params
  })
}
// 退货订单
export function refundList(params) {
  return request({
    url: '/returnApply/list',
    method: 'get',
    params: params
  })
}
// 取消发货
export function cancelDelivery(params) {
  return request({
    url: '/order/cancel/delivery',
    method: 'post',
    data: params
  })
}
export function orderLogistics(params) { // 物流信息
  return request({
    url: '/order/alogistics',
    method: 'GET',
    params
  })
}
export function ordersLogistics(params) { // 售后物流信息
  return request({
    url: '/order/salogistics',
    method: 'GET',
    params
  })
}
export function refundalogistics(params) { // 售后商家寄回物流
  return request({
    url: '/order/refundalogistics',
    method: 'GET',
    params
  })
}
// 核销订单
export function mentionList(params) {
  return request({
    url: '/order/mention/list',
    method: 'get',
    params: params
  })
}
// 自提核销
export function orderWriteOff(params) {
  return request({
    url: '/order/write_off',
    method: 'post',
    data: params
  })
}

// 商户查询用户信息
export function getAddressShowNum(params) {
  return request({
    url: '/order/getAddressShowNum',
    method: 'get',
    params: params
  })
}

export function jushuitanOrder(params){
  return request({
    url: '/order/jushuitanOrder',
    method: 'get',
    params: params
  })
}

export function getSupplierOrderDetail(params){
  return request({
    url: '/mcht/supply/getSupplierOrderDetail',
    method: 'get',
    params: params
  })
}



// WEBPACK FOOTER //
// ./src/api/order.js